import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme?.palette?.lightBackground?.main,
    borderRadius: '5px',
    marginBottom: '5px',
    width: '100%',
  },
  indexWrapper: {
    display: 'flex',
    justifyContent: 'center',
    boxSizing: 'border-box',
    width: '30px',
    height: '30px',
    margin: '10px',
    borderRadius: '4px',
    background: (props) =>
      theme?.palette?.[
        `${props.isSolved ? 'primaryButton' : 'secondaryButton'}`
      ]?.main,
    color: (props) =>
      props.isSolved
        ? theme?.palette?.primaryButton?.contrastText
        : theme?.palette?.darkTextColor?.main,
    border: (props) =>
      !props.isSolved ? `solid 1px ${theme?.palette?.borders?.main}` : null,
  },
  indexNumber: {
    fontSize: '12px',
  },
  questionTypeWrapper: {
    boxSizing: 'border-box',
    padding: '9px 0 14px 50px',
    height: '100%',
    width: 'max-content',
    marginRight: 'auto',
  },
  modifyAndSolveButtonWrapper: {
    padding: '5px 10px 10px 0',
  },
  questionWrapper: {
    width: 'calc(100% - 50px)',
    paddingRight: '25px',
    paddingTop: '16px',
    paddingBottom: '5px',
  },
  bottomPart: {
    height: '50px',
    borderTop: `solid 1px ${theme?.palette?.lightDividerLines?.main}`,
  },
  solveButton: {
    boxSizing: 'border-box',
    background: theme?.palette?.primaryButton?.main,
    color: theme?.palette?.primaryButton?.contrastText,
    width: '59px',
    height: '100%',
    minWidth: 0,
    border: `solid 1px ${theme?.palette?.primarySelection?.main}`,
    '&:hover': {
      background: theme?.palette?.primaryButton?.hover,
    },
  },
  modifyButton: {
    boxSizing: 'border-box',
    background: theme?.palette?.secondaryButton?.main,
    color: theme?.palette?.secondaryButton?.contrastText,
    height: '100%',
    width: '59px',
    minWidth: 0,
    border: `solid 1px ${theme?.palette?.primarySelection?.main}`,
  },
  question: {
    overflowWrap: 'break-word',
    msWordBreak: 'break-all',
    wordBreak: 'break-word',
    msHyphens: 'auto',
    MozHyphens: 'auto',
    WebkitHyphens: 'auto',
    hyphens: 'auto',
    whiteSpace: 'pre-wrap',
    lineHeight: '22px',
    fontSize: '14px',
    '& > *': {
      margin: 0,
      padding: 0,
      listStylePosition: 'inside',
    },
    '& > * > img': {
      maxHeight: '100%',
      maxWidth: '100%',
    },
    '& > pre': {
      overflowWrap: 'break-word',
      msWordBreak: 'break-all',
      wordBreak: 'break-word',
      msHyphens: 'auto',
      MozHyphens: 'auto',
      WebkitHyphens: 'auto',
      hyphens: 'auto',
      whiteSpace: 'pre-wrap',
      background: 'black',
      color: 'white',
      fontWeight: 300,
      padding: '5px',
    },
  },
}))
export { useStyles }
